import {
  boPhanSearchColumns,
  chiPhiKhongHopLeSearchColumns,
  dotThanhToanSearchColumns,
  hopDongSearchColumns,
  kheUocSearchColumns,
  lenhSanXuatSearchColumns,
  phiSearchColumns,
  QUERY_KEYS,
  vatTuSearchColumns,
  vuViecSearchColumns
} from '@/constants';
import {
  BoPhan,
  ChiPhiKhongHopLeData,
  DotThanhToan,
  HopDong,
  KheUoc,
  LenhSanXuat,
  Phi,
  VatTu,
  VuViec
} from '@/types/schemas';
import { SearchDialogActions, SearchDialogState } from '../../hooks';
import { SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface ObjectTabProps {
  searchState: {
    state: SearchDialogState;
    actions: SearchDialogActions;
  };
}

const ObjectTab: React.FC<ObjectTabProps> = ({ searchState: { state, actions } }) => {
  return (
    <div className='h-96 w-[800px] min-w-[800px] space-y-4 p-4'>
      <div className='flex flex-col space-y-1'>
        {/* Mã bộ phận */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Bộ phận</Label>
          <SearchField<BoPhan>
            searchEndpoint={`/${QUERY_KEYS.BO_PHAN}/`}
            searchColumns={boPhanSearchColumns}
            dialogTitle='Danh mục bộ phận'
            columnDisplay={`ma_bp`}
            displayRelatedField={`ten_bp`}
            value={state.boPhan?.ma_bp || ''}
            relatedFieldValue={state.boPhan?.ten_bp || ''}
            onRowSelection={actions.setBoPhan}
          />
        </div>

        {/* Mã vụ việc */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Vụ việc</Label>
          <SearchField<VuViec>
            searchEndpoint={`/${QUERY_KEYS.VU_VIEC}/`}
            searchColumns={vuViecSearchColumns}
            dialogTitle='Danh mục vụ việc'
            columnDisplay={`ma_vu_viec`}
            displayRelatedField={`ten_vu_viec`}
            value={state.vuViec?.ma_vu_viec || ''}
            relatedFieldValue={state.vuViec?.ten_vu_viec || ''}
            onRowSelection={actions.setVuViec}
          />
        </div>

        {/* Mã hợp đồng */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Hợp đồng</Label>
          <SearchField<HopDong>
            searchEndpoint={`/${QUERY_KEYS.HOP_DONG}/`}
            searchColumns={hopDongSearchColumns}
            dialogTitle='Danh mục hợp đồng'
            columnDisplay={`ma_hd`}
            displayRelatedField={`ten_hd`}
            value={state.hopDong?.ma_hd || ''}
            relatedFieldValue={state.hopDong?.ten_hd || ''}
            onRowSelection={actions.setHopDong}
          />
        </div>

        {/* Mã đợt thanh toán */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Đợt thanh toán</Label>
          <SearchField<DotThanhToan>
            searchEndpoint={`/${QUERY_KEYS.DOT_THANH_TOAN}/`}
            searchColumns={dotThanhToanSearchColumns}
            dialogTitle='Danh mục đợt thanh toán'
            columnDisplay={`ma_dtt`}
            displayRelatedField={`ten_dtt`}
            value={state.dotThanhToan?.ma_dtt || ''}
            relatedFieldValue={state.dotThanhToan?.ten_dtt || ''}
            onRowSelection={actions.setDotThanhToan}
          />
        </div>

        {/* Mã khế ước */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Khế ước</Label>
          <SearchField<KheUoc>
            searchEndpoint={`/${QUERY_KEYS.KHE_UOC}/`}
            searchColumns={kheUocSearchColumns}
            dialogTitle='Danh mục khế ước'
            columnDisplay={`ma_ku`}
            displayRelatedField={`ten_ku`}
            value={state.kheUoc?.ma_ku || ''}
            relatedFieldValue={state.kheUoc?.ten_ku || ''}
            onRowSelection={actions.setKheUoc}
          />
        </div>

        {/* Mã phí */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Phí</Label>
          <SearchField<Phi>
            searchEndpoint={`/${QUERY_KEYS.PHI}/`}
            searchColumns={phiSearchColumns}
            dialogTitle='Danh mục phí'
            columnDisplay={`ma_phi`}
            displayRelatedField={`ten_phi`}
            value={state.phi?.ma_phi || ''}
            relatedFieldValue={state.phi?.ten_phi || ''}
            onRowSelection={actions.setPhi}
          />
        </div>

        {/* Mã sản phẩm */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Sản phẩm</Label>
          <SearchField<VatTu>
            searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
            searchColumns={vatTuSearchColumns}
            dialogTitle='Danh mục sản phẩm'
            columnDisplay={`ma_vt`}
            displayRelatedField={`ten_vt`}
            value={state.sanPham?.ma_vt || ''}
            relatedFieldValue={state.sanPham?.ten_vt || ''}
            onRowSelection={actions.setSanPham}
          />
        </div>

        {/* Số lệnh */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Lệnh sản xuất</Label>
          <SearchField<LenhSanXuat>
            searchEndpoint={`/${QUERY_KEYS.LENH_SAN_XUAT}/`}
            searchColumns={lenhSanXuatSearchColumns}
            dialogTitle='Danh mục lệnh sản xuất'
            columnDisplay={`so_ct`}
            displayRelatedField={`dien_giai`}
            value={state.lenhSanXuat?.so_ct || ''}
            relatedFieldValue={state.lenhSanXuat?.dien_giai || ''}
            onRowSelection={actions.setLenhSanXuat}
          />
        </div>

        {/* Mã chi phí */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>C/p không h/lệ</Label>
          <SearchField<ChiPhiKhongHopLeData>
            searchEndpoint={`/${QUERY_KEYS.CHI_PHI_KHONG_HOP_LE}/`}
            searchColumns={chiPhiKhongHopLeSearchColumns}
            dialogTitle='Danh mục chi phí'
            columnDisplay={`ma_cp_khl`}
            displayRelatedField={`ten_cp_khl`}
            value={state.chiPhi?.ma_cp_khl || ''}
            relatedFieldValue={state.chiPhi?.ten_cp_khl || ''}
            onRowSelection={actions.setChiPhi}
          />
        </div>
      </div>
    </div>
  );
};

export default ObjectTab;
